import type {FC, PropsWithChildren} from 'react';
import {cn} from '../lib/cn';
import {useSidebarMenuButton} from './useSidebarMenuButton';

export interface SidebarIconProps extends PropsWithChildren {
  isActive?: boolean;
  highlighted?: boolean;
  size?: 'M' | 'L';
  className?: string;
}

export const SidebarIcon: FC<SidebarIconProps> = ({
  children,
  isActive: isActiveProp,
  highlighted: highlightedProp,
  size = 'M',
  className,
}) => {
  const context = useSidebarMenuButton();
  const isActive = context?.isActive ?? isActiveProp ?? false;
  const highlighted = context?.highlighted ?? highlightedProp ?? false;

  const backgroundClassName = (() => {
    if (isActive) {
      return highlighted
        ? 'bg-[var(--chekin-color-surface-autocomplete)]'
        : 'bg-[var(--chekin-color-gray-3)]';
    }

    return highlighted
      ? 'bg-[var(--chekin-color-surface-pressed)]'
      : 'bg-[var(--chekin-color-surface-input-empty)]';
  })();

  return (
    <div
      className={cn(
        'sidebar-icon flex items-center justify-center rounded-[50%] transition-colors ease-in-out',
        backgroundClassName,
        highlighted
          ? 'text-[var(--chekin-color-brand-blue)]'
          : 'text-[var(--chekin-color-gray-1)]',
        !isActive &&
          (highlighted
            ? 'group-hover/menu-button:bg-[var(--chekin-color-surface-autocomplete)]'
            : 'group-hover/menu-button:bg-[var(--chekin-color-gray-3)]'),
        {
          'h-6 w-6 [&>svg]:h-4 [&>svg]:w-4': size === 'M',
          'h-8 w-8 [&>svg]:h-5 [&>svg]:w-5': size === 'L',
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
